import type { MatchesSearch } from './search-schema'
import { queryOptions } from '@tanstack/react-query'
import { listMatches } from './api'

export const MATCHES_REFETCH_INTERVAL_MS = 15_000
export const MATCHES_STALE_TIME_MS = 15_000

export const footballMatchesQueryKeys = {
  all: ['football-matches'] as const,
  list: (search: MatchesSearch) => [...footballMatchesQueryKeys.all, 'list', search] as const,
}

export function matchesQueryOptions(search: MatchesSearch) {
  return queryOptions({
    queryKey: footballMatchesQueryKeys.list(search),
    queryFn: () => listMatches(search),
    refetchInterval: MATCHES_REFETCH_INTERVAL_MS,
    staleTime: MATCHES_STALE_TIME_MS,
  })
}
